import {
  NoResponse,
  NotificationRequest,
} from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { GLOBAL_NOTIFICATIONS, NOTIFICATIONS_BY_USER } from "~/constants";

import { useNotificationsApi } from "./api";

export function useSendNotificationToAll(
  options?: UseMutationOptions<
    AxiosResponse<NoResponse>,
    unknown,
    [number, NotificationRequest]
  >
) {
  const api = useNotificationsApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation(
    (rq) => api.fcmSendAllDevices(...rq, "C1F5891F3C716F3A68CB192A5CA9"),
    {
      onSuccess: async (data, vars, ctx) => {
        isFunction(onSuccess) && onSuccess(data, vars, ctx);
        await queryClient.invalidateQueries([NOTIFICATIONS_BY_USER]);
        await queryClient.invalidateQueries([GLOBAL_NOTIFICATIONS]);
      },
      ...rest,
    }
  );
}
